import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function VoidReasons({ children }) {
  useInjectSaga({ key: 'settingsVoidReasons', saga });
  useInjectReducer({ key: 'settingsVoidReasons', reducer });

  return React.Children.only(children);
}

VoidReasons.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withVoidReasons } from './withVoidReasons';
export default compose(withConnect, memo)(VoidReasons);
